/* eslint-disable filenames/match-regex */
export const ADDON_EXTENSION = 'VVE'; // voucher validity extension
export const ADDON_PAYLATER = 'PLA'; //  Pay Later Amount
export const ADDON_VEA = 'VEA'; // voucher early access
export const ADDON_PMV = 'PMV'; // protect my voucher
export const ADDON_DVP = 'DVP'; // deal voucher product
export const ADDON_GUV = 'GUV'; // gift upsell voucher product
export const ADDON_GDV = 'GDV'; // gift design voucher

export const SECOND_CHECKOUT_SOURCE = 'second_checkout';
export const POST_CHECKOUT_SOURCE = 'my_wowcher';
export const VEA_PURCHASE_SOURCE = 'myVoucher';
export const VEA_PURCHASE_SOURCE_EMAIL = 'email';
